import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4384c090"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content px-3 pb-2 px-md-5 pb-md-4" }
const _hoisted_4 = { class: "modal-header border-0 pb-0" }
const _hoisted_5 = {
  class: "modal-title text-center fw-bold w-100 pb-3",
  id: "yelloopFollowUpModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 fs-7 fw-bold text-lobby mb-2" }, "YELLoop", -1))
const _hoisted_10 = { class: "text-start fw-bold w-100 border-bottom pb-3 mb-3" }
const _hoisted_11 = { class: "text-start mb-0 fw-bold" }
const _hoisted_12 = { class: "text-start ms-3 mb-3" }
const _hoisted_13 = { class: "text-start mb-0 fw-bold" }
const _hoisted_14 = { class: "text-start ms-3 mb-0" }
const _hoisted_15 = { class: "modal-footer border-0 pt-3" }
const _hoisted_16 = { class: "container-fluid px-0" }
const _hoisted_17 = { class: "row flex-column-reverse flex-lg-row g-2" }
const _hoisted_18 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center px-5" }
const _hoisted_19 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center px-5" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop fade show" }, null, -1))

import { ref, onMounted, onUnmounted, watch } from 'vue'
import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useRoute, useRouter } from 'vue-router'
import userServices from '@/services/users.service'
import { buildFormData } from '@/utils'
import { useStore } from 'vuex'
import { computed } from 'vue'
import { YELLOOP_CHECK_REJOIN_INTENTION_VALUES, YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES } from '@/constants/index'
import { COMMUNITY_STORE } from '@/store/constants'
// Define screens skip open follow up modal
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const SKIP_FOLLOW_UP_MODAL: readonly string[] = ['/profile/setting', 'alumni/account/profile/edit', 'alumni/lobby', '/leave_community']
const router = useRouter()
const route = useRoute()
const store = useStore()
const alumniIcon = require('@/assets/images/user-attribute-green.svg')
const isOpen = ref<boolean>(false)
const isLoading = ref<boolean>(false)
const profile = computed(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME]?.profile)
const TARGET_MODAL_ID = 'yelloopFollowUpModal'
const rejoinIntentionName = computed(() => {
  return YELLOOP_CHECK_REJOIN_INTENTION_VALUES[profile.value?.rejoin_intention] ?? ''
})

const desiredInformationName = computed(() => {
  return YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES[profile.value?.desired_information] ?? ''
})

const handleOpenModal = (): void => {
  const isSkipped = SKIP_FOLLOW_UP_MODAL.some((path) => route.path.includes(path))
  if (isSkipped) {
    isOpen.value = false
    return
  }
  isOpen.value = true
}

watch(
  () => isOpen.value,
  (val: boolean) => {
    if (val) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  },
  { immediate: true }
)

const closeModal = (): void => {
  // Don't allow close modal while request API
  if (isLoading.value) return
  isOpen.value = false
}

//  handleSubmit is async/await, keep yelloop check data
const handleSubmit = async (): Promise<void> => {
  if (isLoading.value) return
  isLoading.value = true

  const formSubmit = new FormData()

  buildFormData(formSubmit, {
    keep_yelloop_check: true,
  })

  try {
    const community_id = router.currentRoute.value.params.id
    const response = await userServices.updateProfileCommunityAlumni({
      id: community_id,
      formData: formSubmit,
    })
    if (response?.status === 200) {
      await store.dispatch(COMMUNITY_STORE.ACTIONS.SET_COMMUNITY_INFO, community_id)
    }
  } finally {
    isLoading.value = false
    closeModal()
  }
}

const preventExtraModals = (event: Event) => {
  const openingModal = event.target as HTMLElement
  const targetModal = document.getElementById(TARGET_MODAL_ID)
  const isTargetModalOpen = targetModal?.classList.contains('show')

  // Case 1: Close all modal if open follow up modal
  if (openingModal.id === TARGET_MODAL_ID) {
    const currentOpenModals = document.querySelectorAll('.modal.show')
    currentOpenModals.forEach((modalEl) => {
      if (modalEl.id !== TARGET_MODAL_ID) {
        const instance = Modal.getInstance(modalEl)
        instance?.hide()
      }
    })
    return
  }

  // Case 2: when follow up modal is opening, not allow open modal
  if (isTargetModalOpen && openingModal.id !== TARGET_MODAL_ID) {
    event.preventDefault()
  }
}

onMounted(() => {
  window.addEventListener('app:open-modal', handleOpenModal)
  document.addEventListener('show.bs.modal', preventExtraModals)
})

onUnmounted(() => {
  window.removeEventListener('app:open-modal', handleOpenModal)
  document.removeEventListener('show.bs.modal', preventExtraModals)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (isOpen.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal fade show d-block",
          id: TARGET_MODAL_ID,
          tabindex: "-1",
          "aria-labelledby": "yelloopFollowUpModalLabel",
          "aria-modal": "true",
          role: "dialog"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('YELLOOP_CHECK_FOLLOW_UP_MODAL_HEADER')), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: _unref(alumniIcon),
                    alt: "Alumni Icon",
                    class: "mb-2 pb-1"
                  }, null, 8, _hoisted_8),
                  _hoisted_9
                ]),
                _createElementVNode("h6", _hoisted_10, _toDisplayString(_unref(translate)('YELLOOP_CHECK_FOLLOW_UP_MODAL_TITLE')), 1),
                _createElementVNode("p", _hoisted_11, "【" + _toDisplayString(_unref(translate)('SA20YelloopCheckRejoinIntentionLabel')) + "】", 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(rejoinIntentionName)), 1),
                _createElementVNode("p", _hoisted_13, "【" + _toDisplayString(_unref(translate)('SA20YelloopCheckDesiredInformationLabel')) + "】", 1),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(desiredInformationName)), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(Button, {
                        title: _unref(translate)('YELLOOP_CHECK_FOLLOW_UP_MODAL_BUTTON_2'),
                        type: 'secondary',
                        disabled: isLoading.value,
                        loading: isLoading.value,
                        class: "button-submit fw-bold",
                        onClick: handleSubmit
                      }, null, 8, ["title", "disabled", "loading"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_router_link, {
                        to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(router).currentRoute.value.params.id}/account/profile/setting`,
                        class: _normalizeClass(["shadow fs-75 border rounded-pill text-center text-black text-decoration-none fw-bold", { 'pe-none opacity-50': isLoading.value }])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Button, {
                            title: _unref(translate)('YELLOOP_CHECK_FOLLOW_UP_MODAL_BUTTON_1'),
                            type: 'secondary',
                            disabled: isLoading.value,
                            class: "fw-bold",
                            onClick: closeModal
                          }, null, 8, ["title", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["to", "class"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_20
      ]))
    : _createCommentVNode("", true)
}
}

})